import React from 'react'
import NotificationCoverModel from '../../../../NotificationCoverModel'
import i18next from 'i18next'

const NewPollNotification = ({ notification, project, sender }) => {
  const lang = i18next.language
  const rtl = lang === 'ar'
  const content = rtl
    ? `أرسل اليك ${sender?.name} تصويتاً فى ${project?.name}`
    : `${sender?.name} has sent you a new voting from ${project?.name} to provide your opinion for`
  return (
    <NotificationCoverModel
      notification={notification}
      notifCoverContent={content}
    />
  )
}

export default NewPollNotification
